import type { ReactNode } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';

export interface SiteLayoutProps {
  children: ReactNode;
}

export const SiteLayout = ({ children }: SiteLayoutProps) => {
  return (
    <div className="app-shell">
      <Navigation />
      <main className="app-content">{children}</main>
      <Footer />
    </div>
  );
};
